{
    "Policies_Bound.search.assignedTo": "Assigned To",
    "Policies_Bound.search.allBrokers": "All Brokers",
    "Policies_Bound.search.allProducts": "All Products",
    "Policies_Bound.search.phone": "Phone",
    "Policies_Bound.search.email": "Email",
    "Policies_Bound.search.clear": "Clear",

    "Policies_Bound.table.referenceNumber": "Reference Number",
    "Policies_Bound.table.policyNumber": "Policy Number",
    "Policies_Bound.table.name": "Name",
    "Policies_Bound.table.doingBusinessAs": "Doing Business As",
    "Policies_Bound.table.product": "Product",
    "Policies_Bound.table.creationDate": "Creation Date",
    "Policies_Bound.table.assignedTo": "Assigned To",
    "Policies_Bound.table.type": "Type",
    "Policies_Bound.table.fname": "First Name",
    "Policies_Bound.table.lname": "Last Name",
    "Policies_Bound.table.search": "Search"
}
